import { AuthGuard } from './auth-guard.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AdminAuthGuard extends AuthGuard {

  canActivate(route, state: RouterStateSnapshot) {
    let isAuthenticated = super.canActivate(route, state);
    if (!isAuthenticated)
      return false;

    if (this.currentUser && this.currentUser.admin)
      return true;

   this.router.navigate(['/no-access']);
    // this.router.navigate(['/login']);
    return false;
  }
  get currentUser() {
    return this.authService.currentUser;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/admin-auth-guard.service.ts